"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Dimmer = _interopRequireDefault(require("./Dimmer"));

exports.default = _Dimmer.default;